<template>
  <div 
    :class="['toast', `toast_${type}`]"
    @click="handleClick"
  >
    <!-- Icon -->
    <BaseMaterialDesignIcon
      :icon="iconName"
      class="toast__icon"
    />
    
    <!-- Message -->
    <span class="toast__message">{{ message }}</span>
    
    <!-- Close button -->
    <button
      class="toast__close-btn"
      @click.stop="handleClose"
    >
      <BaseMaterialDesignIcon
        icon="close"
        class="toast__close-btn-icon"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: 'ToastItem',
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    actions: {
        type: Array,
        default: () => []
    },
    options: {
        type: Object,
        default: () => {}
    }
  },
  computed: {
    iconName() {
      const iconMap = {
        success: 'check',
        error: 'alertCircleOutline',
        info: 'informationOutline'
      }
      return this.options?.icon || iconMap[this.type] || 'info'
    },
    
    // showCloseButton() {
    //   return this.options.action && this.options.action.icon === 'times'
    // },
    
    // hasClickAction() {
    //   return this.options.action && this.options.action.onClick
    // }
  },
  methods: {
    handleClick(event) {
      // Don't trigger if clicking on close button
      if (event.target.tagName === 'BUTTON' || event.target.closest('button')) {
        return
      }
      
      // TODO: handle click action
    },
    
    handleClose() {
      this.$emit('remove', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
    background: #757575;
    color: white;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0 8px 8px -8px $rfx-quarter-march;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 300px;
    max-width: 400px;
    pointer-events: auto;
    top: 45px;
    position: relative;
    cursor: default;

    &_success {
        background: $rfx-dark-march;

        .toast__icon {
            color: $rfx-bright-turquoise;
        }
    }

    &_error {
        background: $rfx-red;
    }

    &_info {
        background: $rfx-dark-march;
    }
}

.toast__icon {
  font-size: 22px;
  color: white;

}

.toast__message {
  flex: 1;
  font-size: 16px;
}

.toast__close-btn {
  background: none;
  border: none;
  color: $rfx-text-light-low-contrast;
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  font-size: 14px;
  opacity: 0.8;
}

.toast__close-btn-icon {
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast__close-btn:hover {
  opacity: 1;
}

.toast__close-btn:focus {
  outline: none;
}

/* Make toast clickable if it has an action */
.toast_clickable {
  cursor: pointer;
}
</style> 